import * as React from 'react'
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DeviceList } from "@/components/sensory"
import { AddDeviceComposer } from "@/forms/sensory"
import { Button } from "@/components/ui/button"
import { ArrowLeft } from "lucide-react"
import { useToast } from "@/contexts/ToastContext"

type View = 'list' | 'create'

export const Route = createFileRoute("/sensory/devices/")({
  staticData: {
    title: 'Devices',
    isSecured: true,
  },
  component: DevicesPage,
})

function DevicesPage() {
  const navigate = useNavigate()
  const { toast } = useToast()
  const [view, setView] = React.useState<View>('list')
  const [listKey, setListKey] = React.useState(0)

  const handleAdd = () => {
    setView('create')
  }

  const handleBack = () => {
    setView('list')
  }

  const handleCreateSuccess = () => {
    toast({ title: 'Success', description: 'Device created successfully.', type: 'success' })
    setListKey((k) => k + 1)
    setView('list')
  }

  const handleError = (error: Error) => {
    toast({ title: 'Error', description: error.message, type: 'error' })
  }

  if (view === 'create') {
    return (
      <div className="p-6 space-y-4">
        <Button variant="ghost" className="gap-2" onClick={handleBack}>
          <ArrowLeft className="h-4 w-4" />
          Back to Devices
        </Button>
        <AddDeviceComposer
          onSuccess={handleCreateSuccess}
          onError={handleError}
          onCancel={handleBack}
        />
      </div>
    )
  }

  return (
    <div className="p-6">
      <DeviceList
        key={listKey}
        onAdd={handleAdd}
        onSelectDevice={(device) => {
          navigate({
            to: "/sensory/devices/$deviceNumber",
            params: { deviceNumber: device.deviceNumber.toString() }
          })
        }}
      />
    </div>
  )
}
